export const FETCH_RD_FILTER_CUSTOMERS_REQUEST = "FETCH_RD_FILTER_CUSTOMERS_REQUEST";
export const FETCH_RD_FILTER_CUSTOMERS_SUCCESS = "FETCH_RD_FILTER_CUSTOMERS_SUCCESS";
export const FETCH_RD_FILTER_CUSTOMERS_FAILURE = "FETCH_RD_FILTER_CUSTOMERS_FAILURE";

export const FETCH_RD_FILTER_LOCATIONS_REQUEST = "FETCH_RD_FILTER_LOCATIONS_REQUEST";
export const FETCH_RD_FILTER_LOCATIONS_SUCCESS = "FETCH_RD_FILTER_LOCATIONS_SUCCESS";
export const FETCH_RD_FILTER_LOCATIONS_FAILURE = "FETCH_RD_FILTER_LOCATIONS_FAILURE";

export const FETCH_RD_FILTER_PROVIDERS_REQUEST = "FETCH_RD_FILTER_PROVIDERS_REQUEST";
export const FETCH_RD_FILTER_PROVIDERS_SUCCESS = "FETCH_RD_FILTER_PROVIDERS_SUCCESS";
export const FETCH_RD_FILTER_PROVIDERS_FAILURE = "FETCH_RD_FILTER_PROVIDERS_FAILURE";

export const FETCH_REPORT_DASHBOARD_REQUEST = "FETCH_REPORT_DASHBOARD_REQUEST";
export const FETCH_REPORT_DASHBOARD_SUCCESS = "FETCH_REPORT_DASHBOARD_SUCCESS";
export const FETCH_REPORT_DASHBOARD_FAILURE = "FETCH_REPORT_DASHBOARD_FAILURE";

export const FETCH_PROVIDER_TIME_SUMMARY_REQUEST = "FETCH_PROVIDER_TIME_SUMMARY_REQUEST";
export const FETCH_PROVIDER_TIME_SUMMARY_SUCCESS = "FETCH_PROVIDER_TIME_SUMMARY_SUCCESS";
export const FETCH_PROVIDER_TIME_SUMMARY_FAILURE = "FETCH_PROVIDER_TIME_SUMMARY_FAILURE";

export const FETCH_PATIENT_ENGAGEMENT_REQUEST = "FETCH_PATIENT_ENGAGEMENT_REQUEST";
export const FETCH_PATIENT_ENGAGEMENT_SUCCESS = "FETCH_PATIENT_ENGAGEMENT_SUCCESS";
export const FETCH_PATIENT_ENGAGEMENT_FAILURE = "FETCH_PATIENT_ENGAGEMENT_FAILURE";

export const FETCH_ADHERENCE_TREND_REQUEST = "FETCH_ADHERENCE_TREND_REQUEST";
export const FETCH_ADHERENCE_TREND_SUCCESS = "FETCH_ADHERENCE_TREND_SUCCESS";
export const FETCH_ADHERENCE_TREND_FAILURE = "FETCH_ADHERENCE_TREND_FAILURE";

export const FETCH_RTM_CLAIMS_REQUEST = "FETCH_RTM_CLAIMS_REQUEST";
export const FETCH_RTM_CLAIMS_SUCCESS = "FETCH_RTM_CLAIMS_SUCCESS";
export const FETCH_RTM_CLAIMS_FAILURE = "FETCH_RTM_CLAIMS_FAILURE";

export const FETCH_RTM_CLAIM_DETAILS_REQUEST = "FETCH_RTM_CLAIM_DETAILS_REQUEST";
export const FETCH_RTM_CLAIM_DETAILS_SUCCESS = "FETCH_RTM_CLAIM_DETAILS_SUCCESS";
export const FETCH_RTM_CLAIM_DETAILS_FAILURE = "FETCH_RTM_CLAIM_DETAILS_FAILURE";

export const SET_PATIENT_ENGAGEMENT_THRESHOLDS = "SET_PATIENT_ENGAGEMENT_THRESHOLDS";

export const SET_REPORT_DASHBOARD_ACTIVE_SECTION = "SET_REPORT_DASHBOARD_ACTIVE_SECTION";
export const SET_REPORT_DASHBOARD_FILTER = "SET_REPORT_DASHBOARD_FILTER";
export const RESET_REPORT_DASHBOARD_FILTERS = "RESET_REPORT_DASHBOARD_FILTERS";
export const SNAPSHOT_FILTERS_BEFORE_RTM = "SNAPSHOT_FILTERS_BEFORE_RTM";
export const RESTORE_FILTERS_FROM_RTM_SNAPSHOT = "RESTORE_FILTERS_FROM_RTM_SNAPSHOT";
export const RESET_REPORT_DASHBOARD = "RESET_REPORT_DASHBOARD";
